import { withInstall } from '@ll-plus/utils'

import Qrcode from './src/qrcode.vue'

export const LlQrcode = withInstall(Qrcode)
export default LlQrcode
export * from './src/qrcode'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlQrcode: typeof Qrcode
  }
}
